import { get, matches, overEvery, overSome, pipe, prop } from 'lodash/fp';

import { CLIENT_PLATFORM, MODULE_NAME } from './constants';

const moduleSelector = prop(MODULE_NAME);

export const createClientInfoSelector = (path) => pipe(moduleSelector, get(path));

export const isDarkModeSelector = createClientInfoSelector('isDarkMode');

export const isFaceIdAvailableSelector = createClientInfoSelector('isFaceIdAvailable');

export const isBiometricAuthAvailableSelector = pipe(
	moduleSelector,
	overSome([prop('isFaceIdAvailable'), prop('isTouchIdAvailable')])
);

export const isBiometricAuthDeclinedSelector = createClientInfoSelector('isFingerprintDeclined');

export const isBiometricAuthSetSelector = createClientInfoSelector('isFingerprintSet');

export const isDeviceAuthorizationEnabledSelector = createClientInfoSelector(
	`isDeviceAuthorizationsEnabled`
);

export const isLoadingSelector = createClientInfoSelector('isLoading');

export const isPlatformAndroidSelector = pipe(
	moduleSelector,
	matches({ platform: CLIENT_PLATFORM.ANDROID })
);

export const isPlatformWebSelector = pipe(
	moduleSelector,
	matches({ platform: CLIENT_PLATFORM.WEB })
);

export const isInitializedSelector = pipe(moduleSelector, (state) =>
	state.platform === CLIENT_PLATFORM.WEB ? Boolean(state.screenSize) : Boolean(state.deviceUuid)
);

export const isNativeBackEnabledSelector = createClientInfoSelector('isNativeBackEnabled');

export const isPinSetSelector = createClientInfoSelector('isPinSet');

export const isTouchIdAvailableSelector = createClientInfoSelector('isTouchIdAvailable');

export const deviceNameSelector = createClientInfoSelector('deviceName');

export const deviceUuidSelector = createClientInfoSelector('deviceUuid');

export const platformSelector = createClientInfoSelector('platform');

export const screenOrientationSelector = createClientInfoSelector('screenOrientation');

export const screenSizeSelector = createClientInfoSelector('screenSize');

export const isPrimaryDeviceSelector = createClientInfoSelector(`isPrimaryDevice`);

export const isPushNotificationAvailableSelector = createClientInfoSelector(
	'isPushNotificationAvailable'
);

export const isPushNotificationOptInSelector = createClientInfoSelector('isPushNotificationOptIn');

export const isPushNotificationPermittedSelector = createClientInfoSelector(
	'isPushNotificationPermitted'
);

export const isPushNotificationPromptedSelector = createClientInfoSelector(
	'isPushNotificationPrompted'
);

export const isPushNotificationEnabledSelector = overEvery([
	isPushNotificationPermittedSelector,
	isPushNotificationOptInSelector,
]);

export const useLightColorToneStatusBarSelector = createClientInfoSelector(
	'useLightColorToneStatusBar'
);

export const getLaunchSourceSelector = createClientInfoSelector('launchSource');
